import { allCompleted } from "../store/chekListReducer";
import { getCheckList } from "./getCheckList";
import request from "../Requests/requests";


export const AllCheckListCompleted = (payload) => {
    return async dispatch => {
        try {
            const response = await request.put('/Checklist/CompletedAll?TaskId=' + payload)
            .then(() => dispatch(allCompleted(payload)))
            .then(() => dispatch(getCheckList(payload)))
            const data = response.data
            return data
        } catch (error) {
            return error
        }
    }
}